import React from 'react';
import project_orbit from '../images/project-orbit.png';
import project_saverpe from '../images/project-saverpe.png';
import project_jobspri from '../images/project-jobspri.png';
import project_jobfect from '../images/project-jobfect.png';
import project_jotcv from '../images/project-jotcv.png';
import project_spungua from '../images/project-spungua.png';

function Portfolio() {
    const projects = [
        {
            title: "Orbit – B2B Loyalty & Voucher Platform",
            category: "Enterprise Platform",
            img: project_orbit,
            url: "https://www.orbit.saverpe.com/",
            description: "Architected and developed a scalable B2B loyalty management platform managing USD 15M annually."
        },
        {
            title: "SaverPe B2C Voucher Platform",
            category: "E-commerce",
            img: project_saverpe,
            url: "https://www.saverpe.com/",
            description: "Secure voucher gifting platform handling USD 7M in yearly transactions with robust validation."
        },
        {
            title: "JobsPri – Recruitment Platform",
            category: "SaaS Platform",
            img: project_jobspri,
            url: "https://www.jobspri.com/",
            description: "Full-scale recruitment platform with role-based access, interview scheduling, and video functionality."
        },
        {
            title: "JOBFECT – Job Search Platform",
            category: "Web Application",
            img: project_jobfect,
            url: "https://www.jobfect.com/",
            description: "Comprehensive job search system with resume parsing and candidate matching functionality."
        },
        {
            title: "JotCV – Resume Builder Platform",
            category: "SaaS Tool",
            img: project_jotcv,
            url: "https://www.jotcv.com/",
            description: "Professional resume builder with dynamic templates and seamless job application integration."
        },
        {
            title: "Spungua – Events & Sports Platform",
            category: "Marketplace",
            img: project_spungua,
            url: "https://www.spungua.com/",
            description: "Event and group-based platform for sports with Stripe payment integration and service matching."
        }
    ];

    return (
        <div className="rn-portfolio-area rn-section-gap section-separator" id="portfolio">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span className="subtitle">Visit my portfolio and keep your feedback</span>
                            <h2 className="title">My Portfolio</h2>
                        </div>
                    </div>
                </div>
                <div className="row row--25 mt--10 mt_md--10 mt_sm--10">
                    {projects.map((project, index) => (
                        <div key={index} data-aos="fade-up" data-aos-delay={100 * (index + 1)} data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-12 mt--50 mt_md--30 mt_sm--30">
                            <div className="rn-portfolio">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <a href={project.url} target="_blank" rel="noopener noreferrer">
                                            <img src={project.img} alt={project.title} style={{ objectFit: 'cover', minHeight: '230px' }} />
                                        </a>
                                    </div>
                                    <div className="content">
                                        <div className="category-info">
                                            <div className="category-list">
                                                <a href={project.url} target="_blank" rel="noopener noreferrer">{project.category}</a>
                                            </div>
                                            <div className="meta">
                                                <span>
                                                    <a href="#"><i className="feather-heart" /></a>
                                                    {600 + index * 50}
                                                </span>
                                            </div>
                                        </div>
                                        <h4 className="title">
                                            <a href={project.url} target="_blank" rel="noopener noreferrer">
                                                {project.title}
                                                <i className="feather-arrow-up-right" />
                                            </a>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Portfolio;
